import { AlertTriangle } from "lucide-react";

interface LowStockAlertProps {
  count: number;
  onClick: () => void;
}

const LowStockAlert = ({ count, onClick }: LowStockAlertProps) => {
  if (count <= 0) return null;

  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 bg-orange-50 border border-orange-200 rounded-lg px-4 py-3 text-left hover:bg-orange-100 transition-colors"
    >
      <AlertTriangle className="h-5 w-5 text-orange-500 flex-shrink-0" />
      <span className="text-orange-700 font-medium text-sm">
        {count} ingr&eacute;dient{count > 1 ? "s" : ""} en stock faible
      </span>
    </button>
  );
};

export default LowStockAlert;
